
<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

@Component()
export default class MenuItem extends Vue {

  isSelected: Boolean = false;
  created() {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)){
        this.closeMenu();
      }
    });
  }

  closeMenu() {
    this.isSelected = false;
  }

  menuClicked() {
    this.isSelected = !this.isSelected;
  }
}
</script>
